function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "icons/round/location"
}, React.createElement("path", {
  id: "Combined Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 16C32 24.8365 24.8366 32 16 32C7.16344 32 0 24.8365 0 16C0 7.16345 7.16344 0 16 0C24.8366 0 32 7.16345 32 16ZM16.597 25.4238C18.0852 25.4238 23.9831 18.735 23.9831 14.2505C23.9831 9.95776 20.6289 6.40002 16.597 6.40002C12.354 6.40002 9 9.95776 9 14.2505C9 18.735 14.8978 25.4238 16.597 25.4238ZM20 13.5C20 15.433 18.433 17 16.5 17C14.567 17 13 15.433 13 13.5C13 11.567 14.567 10 16.5 10C18.433 10 20 11.567 20 13.5Z",
  fill: "#222222"
}));

var SvgLocation = function SvgLocation(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imljb25zL3JvdW5kL2xvY2F0aW9uIj4KPHBhdGggaWQ9IkNvbWJpbmVkIFNoYXBlIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMyIDE2QzMyIDI0LjgzNjUgMjQuODM2NiAzMiAxNiAzMkM3LjE2MzQ0IDMyIDAgMjQuODM2NSAwIDE2QzAgNy4xNjM0NSA3LjE2MzQ0IDAgMTYgMEMyNC44MzY2IDAgMzIgNy4xNjM0NSAzMiAxNlpNMTYuNTk3IDI1LjQyMzhDMTguMDg1MiAyNS40MjM4IDIzLjk4MzEgMTguNzM1IDIzLjk4MzEgMTQuMjUwNUMyMy45ODMxIDkuOTU3NzYgMjAuNjI4OSA2LjQwMDAyIDE2LjU5NyA2LjQwMDAyQzEyLjM1NCA2LjQwMDAyIDkgOS45NTc3NiA5IDE0LjI1MDVDOSAxOC43MzUgMTQuODk3OCAyNS40MjM4IDE2LjU5NyAyNS40MjM4Wk0yMCAxMy41QzIwIDE1LjQzMyAxOC40MzMgMTcgMTYuNSAxN0MxNC41NjcgMTcgMTMgMTUuNDMzIDEzIDEzLjVDMTMgMTEuNTY3IDE0LjU2NyAxMCAxNi41IDEwQzE4LjQzMyAxMCAyMCAxMS41NjcgMjAgMTMuNVoiIGZpbGw9IiMyMjIyMjIiLz4KPC9nPgo8L3N2Zz4K";
export { SvgLocation as ReactComponent };